module.exports = __webpack_public_path__ + "img/nysy-selected.859b9792.png";